module.exports = __webpack_public_path__ + "static/media/credit.e0e8ea61.svg";